module.exports = __webpack_public_path__ + "img/party.e2a9cdac.jpg";